import { IconText } from '@ps/isp-web-component-library';
import { MarketStatusLost } from '@ps/isp-web-component-library/icons/MarketStatusLost';
import { MarketStatusPlaced } from '@ps/isp-web-component-library/icons/MarketStatusPlaced';
import { MarketStatusVoid } from '@ps/isp-web-component-library/icons/MarketStatusVoid';
import { MarketStatusWon } from '@ps/isp-web-component-library/icons/MarketStatusWon';
import type { ResultType } from '@ps/isp-web-services-types';
import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import type { PropsWithoutRef, SVGProps } from 'react';
import React from 'react';

import {
  TXTWCL_Lost_Xshort_formX,
  TXTWCL_Placed_Xshort_formX,
  TXTWCL_Void_Xshort_formX,
  TXTWCL_Won_Xshort_formX
} from './MarketStatus.messages.json';
import styles from './MarketStatus.scss';

export interface Props {
  result?: ResultType;
}

export interface MarketStatus {
  icon: React.ElementType<PropsWithoutRef<SVGProps<SVGSVGElement>>>;
  label: TranslationTag;
}

export const marketStatusResultMap: Partial<Record<ResultType, MarketStatus>> = {
  WON: {
    icon: MarketStatusWon,
    label: TXTWCL_Won_Xshort_formX
  },
  LOST: {
    icon: MarketStatusLost,
    label: TXTWCL_Lost_Xshort_formX
  },
  PLACED: {
    icon: MarketStatusPlaced,
    label: TXTWCL_Placed_Xshort_formX
  },
  VOID: {
    icon: MarketStatusVoid,
    label: TXTWCL_Void_Xshort_formX
  }
};

const MarketStatus: React.FC<Props> = ({ result }) => {
  const icon = result && marketStatusResultMap[result]?.icon;
  const label = result && marketStatusResultMap[result]?.label;

  return icon && label ? (
    <IconText className={styles.marketStatus}>
      <span className={styles.noTextDecoration}>
        <IconText.Text>
          <Translation {...label} />
        </IconText.Text>
      </span>

      <IconText.Icon size="sm" className={styles.marketStatusIcon} icon={icon} />
    </IconText>
  ) : null;
};

export default MarketStatus;
